module.exports = __webpack_public_path__ + "static/media/check.3fc3ee3c.svg";